import { notify } from 'utils/reduxUtils';

export const types = {
  DEEP_COPY_QUOTE_ITEM_IN_PLACE_ERROR:
    'baq/sideNav/deepCopyInPlaceModal/DEEP_COPY_QUOTE_ITEM_IN_PLACE_ERROR',
  DEEP_COPY_QUOTE_ITEM_IN_PLACE_REQUEST:
    'baq/sideNav/deepCopyInPlaceModal/DEEP_COPY_QUOTE_ITEM_IN_PLACE_REQUEST',
  DEEP_COPY_QUOTE_ITEM_IN_PLACE_SUCCESS:
    'baq/sideNav/deepCopyInPlaceModal/DEEP_COPY_QUOTE_ITEM_IN_PLACE_SUCCESS',

  MODAL_CLOSE: 'baq/sideNav/deepCopyInPlaceModal/MODAL_CLOSE',
  MODAL_OPEN: 'baq/sideNav/deepCopyInPlaceModal/MODAL_OPEN',
};

export const deepCopyInPlaceModal = {
  open: ({ quoteItemId }) => ({
    type: types.MODAL_OPEN,
    payload: { quoteItemId },
  }),
  close: () => ({
    type: types.MODAL_CLOSE,
  }),
};

export const deepCopyInPlaceQuoteItem = {
  error: notify(
    (error) => ({
      type: types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_ERROR,
      payload: error,
    }),
    'Failed to replace referenced part with new version',
  ),
  request: () => ({
    type: types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_REQUEST,
  }),
  success: () => ({
    type: types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_SUCCESS,
  }),
};
